import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'swb-appearance',
  templateUrl: './appearance.component.html'
})
export class AppearanceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
